import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75ada372"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "footer-items" }
const _hoisted_3 = { class: "footer-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "FitTrackee", -1))
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-item bullet\" data-v-75ada372>•</div><div class=\"footer-item\" data-v-75ada372><a href=\"https://github.com/SamR1/FitTrackee\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-75ada372> source code </a> under <a href=\"https://choosealicense.com/licenses/agpl-3.0/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-75ada372> AGPLv3 </a>license </div><div class=\"footer-item bullet\" data-v-75ada372>•</div><div class=\"footer-item\" data-v-75ada372><a href=\"https://samr1.github.io/FitTrackee/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-75ada372> documentation </a></div>", 4)

import { toRefs } from 'vue'

  interface Props {
    version: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    version: null
  },
  setup(__props: any) {

const props = __props as {
    version: string
  }

  

  const { version } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" v" + _toDisplayString(_unref(version)), 1)
      ]),
      _hoisted_5
    ])
  ]))
}
}

})